module.exports = __webpack_public_path__ + "static/pecan-pie-baby-c4a5948c9862ca473890ef7f775bdce3.jpg";